import { FC, useEffect } from 'react';
import { Col, Row } from 'antd';

import { getBalance, getDocuments } from 'features/overview/actions';

import { Wallet } from './Wallet';
import { ProfitStatus } from './ProfitStatus';
import { Balance } from './Balance';
import { LoyaltyStatus } from './LoyaltyStatus';
import { Investments } from './Investments';
import { RejectedMessage } from 'componets/ui';
import { BearLossCalculator } from './BearLossCalculator';

import { useAppDispatch, useAppSelector } from 'hooks';

import { RequestStatus, SECOND } from 'utils/constants';

import './index.scss';

export const Overview: FC = () => {
	const { status, timeBalanceLoaded } = useAppSelector((state) => state.overview);

	const dispatch = useAppDispatch();

	useEffect(() => {
		if (!timeBalanceLoaded || new Date().getTime() - timeBalanceLoaded > SECOND) {
			dispatch(getBalance());
		}
	}, [dispatch, timeBalanceLoaded]);

	useEffect(() => {
		dispatch(getDocuments());
	}, [dispatch]);

	const isLoading = status === RequestStatus.PENDING;
	const isRejected = status === RequestStatus.REJECTED;

	return (
		<>
			{!isRejected && (
				<Row gutter={[32, 24]} style={{ paddingBottom: '55px' }}>
					<Col className="gutter-row" xl={24 / 3} md={24 / 2} sm={24} xs={24}>
						<Balance isLoading={isLoading} />
					</Col>

					<Col className="gutter-row" xl={24 / 3} md={24 / 2} sm={24} xs={24}>
						<Wallet isLoading={isLoading} />
					</Col>
					<Col className="gutter-row" xl={24 / 3} md={24 / 2} sm={24} xs={24}>
						<LoyaltyStatus isLoading={isLoading} />
					</Col>

					<Col className="gutter-row gutter-row-tablet" xl={24 / 3} md={24 / 2} sm={24} xs={24}>
						<Investments isLoading={isLoading} />
					</Col>
					<Col className="gutter-row" xl={16} md={24} sm={24} xs={24}>
						<ProfitStatus />
					</Col>
					<Col xl={8} md={24} sm={24} xs={24} className="gutter-column">
						<div className="gutter-row-desktop">
							<Investments isLoading={isLoading} />
						</div>
						<BearLossCalculator />
					</Col>
				</Row>
			)}

			{isRejected && <RejectedMessage />}
		</>
	);
};
